import { useFormContext, useFormField } from '@calendly/form'
import { useCallback } from 'react'

export const useTextField = (props) => {
  const [{ value: currentVariant }] = useFormField({ name: 'variant' })
  const [fieldProps, meta] = useFormField(props)

  const { setFieldValue, setTouched } = useFormContext()

  const onChange = useCallback((value) => {
    if (value.source !== 'user') {
      return
    }

    setFieldValue(props.name, value, false)

    // These conditions are for optimization / reduce rerenders
    if (currentVariant !== 'custom') {
      setFieldValue('variant', 'custom')
    }

    if (!meta.touched) {
      setTouched({ [props.name]: true }, false)
    }
  }, [currentVariant, meta.touched, props.name, setFieldValue, setTouched])

  return { ...fieldProps, onChange }
}
